import React from 'react';
import { Form, Checkbox, message, Pagination } from 'antd';
import ModalDom from '../../../../../components/Modal';
import SuperForm from '../../../../../components/SuperForm';
import { postFrom, config } from '../../../../../axios';
import { moneyAddComma, handleDeepCopy } from '../../../../../utils';
import moment from 'moment'

class Page extends React.Component {
    constructor() {
        super();
        this.initState = {
            loading: false,
            data: [],
            useData: [],
            payOtherBillVoList: [],
            params: { //搜索参数
                receiveOrPay: 1, //收款账单
                receiveStatus: 2, //未收状态
                billBeginDate: "", //日期-起始
                billEndDate: "", //日期-结束
                buildingName: "", //小区、楼栋
                roomNo: "", //房号
            },
            current: 1, //合同分页
            pageSize: 10,
        };
        this.state = {
            ...handleDeepCopy(this.initState)
        };
    }

    searchData = () => [
        {
            tagName: 'DatePicker',
            formItem: { label: '应收日期' },
            formConfig: { name: 'mustPayDateStart' },
            attribute: { placeholder: '请选择', style: { width: '110px' } },
        },
        {
            tagName: 'DatePickerEnd',
            formConfig: { name: 'mustPayDateEnd' },
            attribute: { placeholder: '请选择', style: { width: '110px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'buildingName' },
            attribute: { placeholder: '楼栋', style: { width: '160px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'roomNo' },
            attribute: { placeholder: '房号', style: { width: '160px' } },
        },
    ];

    handleCancel = () => { //关闭页面
        this.setState({ ...handleDeepCopy(this.initState) }, () => {
            this.props.handleCancel();
        });
    }

    loadPackage = (id) => {
        this.customerId = id;
        this.handleSearch();
    }

    onChange = (page) => { //改变分页
        let { data, useData, pageSize, payOtherBillVoList } = this.state;
        useData = data.slice((page - 1) * pageSize);
        if (useData.length > pageSize) {
            useData = useData.slice(0, pageSize);
        }
        this.setState({ current: page, useData });
        this.props.form.setFieldsValue({ payOtherBillVoList: payOtherBillVoList[page - 1] })
    };

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, pageSize } = this.state;
        params = Object.assign({ customerId: this.customerId }, params, values);
        this.setState({ params, loading: true });
        postFrom({ url: config.API_bill_findBillPageList, data: params }).then(res => {
            let totalPage = Math.ceil(res.records.length / pageSize);
            this.setState({ data: res.records, loading: false, payOtherBillVoList: new Array(totalPage).fill([]) }, () => {
                this.onChange(1);
            });
        }).catch(err => {
            message.error(err.message || '获取收款账单失败');
            this.setState({ loading: false });
        })
    }

    handleOk = () => {
        let { data, payOtherBillVoList } = this.state;
        let newData = payOtherBillVoList.filter(item => item.length);
        let valueData = [];
        for (let i = 0; i < newData.length; i++) {
            let nowArr = newData[i].map(item => data.find(item2 => item === item2.id));
            valueData = valueData.concat(nowArr);
        }
        this.props.setList(valueData);
        this.props.handleCancel();
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    render() {
        let { visible, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            data,
            useData,
            payOtherBillVoList,
        } = this.state;

        return <ModalDom
            title="添加"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="search-wrapper" style={{ marginTop: '-3px' }}>
                <SuperForm
                    onRef={ref => this.superFormRef = ref}
                    data={this.searchData()}
                    sumbit={this.handleSearch}
                    addParams={'current'}
                />
            </div>
            <div className="custom">
                <div className="tableBox">
                    <div className="tableTitle">
                        <div style={{ flex: '0 0 50px' }}>选择</div>
                        <div style={{ flex: 1 }}>应收日期</div>
                        <div style={{ flex: 1 }}>房源</div>
                        <div style={{ flex: 1 }}>账单名称</div>
                        <div style={{ flex: 1 }}>账单周期</div>
                        <div style={{ flex: 1 }}>应收金额（元）</div>
                        <div style={{ flex: 1 }}>待收金额（元）</div>
                    </div>
                    <div className="tableBody">
                        {
                            useData.length
                                ? <React.Fragment>
                                    {getFieldDecorator('payOtherBillVoList', {
                                        initialValue: payOtherBillVoList
                                    })(
                                        <Checkbox.Group
                                            style={{ display: 'block' }}
                                            onChange={(value) => {
                                                let { payOtherBillVoList, current,useData } = this.state;
                                                payOtherBillVoList[current - 1] = value;
                                                this.setState({payOtherBillVoList})
                                            }}
                                        >
                                            {
                                                useData.map((item, index) => {
                                                    return <div className="tableBodyRow" style={{ textAlign: 'center' }} key={item.id}>
                                                        <div style={{ flex: '0 0 50px' }}>
                                                            <Checkbox value={item.id}></Checkbox>
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ padding: '5px', lineHeight: '16px' }}>
                                                                <div style={{ color: "red" }}>{item.overdueDays ? `逾期${item.overdueDays}天` : null}</div>
                                                                <div>{item.mustPayDate ? moment(item.mustPayDate).format('YYYY-MM-DD') : ""}</div>
                                                            </div>
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ padding: '5px', lineHeight: '18px' }}>
                                                                <div>{item.roomNo}</div>
                                                                <div>{item.buildingName}</div>
                                                            </div>
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ padding: '5px', lineHeight: '18px' }}>
                                                                {item.feeName}
                                                            </div>
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ padding: '5px', lineHeight: '18px' }}>
                                                                <div>{item.billBeginDate ? moment(item.billBeginDate).format('YYYY-MM-DD') : null}</div>
                                                                <div>{item.billEndDate ? moment(item.billEndDate).format('YYYY-MM-DD') : null}</div>
                                                            </div>
                                                        </div>
                                                        <div style={{ flex: 1, justifyContent: 'flex-end' }}>
                                                            <div style={{ padding: '0 25px', lineHeight: '18px', textAlign: 'right' }}>
                                                                <div>{moneyAddComma(item.billMoney)}</div>
                                                            </div>
                                                        </div>
                                                        <div style={{ flex: 1, justifyContent: 'flex-end' }}>
                                                            <div style={{ padding: '0 25px', lineHeight: '18px', color: 'red' }}>
                                                                <div>{moneyAddComma(item.billMoney - item.receivedMoney)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                            }
                                        </Checkbox.Group>
                                    )}
                                    <div className="tableBodyRow" style={{ padding: '10px', justifyContent: 'flex-end' }}>
                                        <Pagination
                                            showTotal={
                                                (total, range) => {
                                                    let { payOtherBillVoList, data } = this.state;
                                                    let totalNow = 0; //总条数
                                                    let pageList = ''; //页数
                                                    let totalMoney = 0; //金额
                                                    for (let i = 0; i < payOtherBillVoList.length; i++) {
                                                        if (payOtherBillVoList[i].length) {
                                                            pageList += `${i + 1}、`;
                                                            totalNow += payOtherBillVoList[i].length;
                                                            let nowArr = payOtherBillVoList[i].map(item => data.find(item2 => item === item2.id));
                                                            totalMoney += nowArr.reduce((total, item) => total + (item.billMoney - item.receivedMoney), 0);
                                                        }
                                                    }
                                                    pageList = pageList.slice(0, -1);
                                                    return (
                                                        <span>
                                                            共{total}个账单
                                                                ；{
                                                                payOtherBillVoList === undefined
                                                                    ? '当前未选择'
                                                                    : <span>
                                                                        已选择<b>{totalNow}</b>笔，共<b>{moneyAddComma(totalMoney)}</b>元{pageList ? <span>，分别在第<b>{pageList}</b>页中</span> : ''}
                                                                    </span>
                                                            }
                                                        </span>
                                                    )
                                                }
                                            }
                                            size="small"
                                            current={this.state.current}
                                            pageSize={this.state.pageSize}
                                            onChange={this.onChange}
                                            total={data.length}
                                        />
                                    </div>
                                </React.Fragment>
                                : <div className="tableBodyRow" style={{ height: '34px', lineHeight: '34px', justifyContent: 'center', color: '#888' }}>暂无数据！</div>
                        }
                    </div>
                </div>
            </div>
        </ModalDom>
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Payment/components/Transfer/CheckIn/Add.js